export enum UserRoleTypeEnum {
    NONE = 0,
    MASTER_ADMIN = 1,
    COMPANY_ADMIN = 11,
    COMPANY_USER = 21,
    PLANT_ADMIN = 51,
    PLANT_USER = 61
}